import React from 'react';
import { Box } from 'grommet';
import SHDText from '@ui/Text/SHDText';
import SHDModalContainer from '@ui/ModalContainer/SHDModalContainer';
import SHDFooter from '@ui/Footer/SHDFooter';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDButton from '@ui/Button/SHDButton';

interface ExitScoringModalProps {
  hideModal: () => void; // Function to close the modal
  onPauseScoring: () => void; // Function for Pause Scoring button
  onEndGame: () => void; // Function for End Game button
}

const ExitScoringModal: React.FC<ExitScoringModalProps> = ({
  hideModal,
  onPauseScoring,
  onEndGame,
}) => {
  return (
    <Box>
      <SHDModalContainer>
        <Box gap="small">
          <SHDHeading level="3" textAlign="start">
            Exit scoring?
          </SHDHeading>
          <SHDText color="black-alpha-70" style="subhead" textAlign="start">
            Pause scoring to pick back up later.
            <br />
            Ending the game will generate a game recap and cannot be undone.
          </SHDText>
        </Box>
      </SHDModalContainer>
      <SHDFooter>
        <SHDModalContainer>
          <Box align="center" gap="small">
            <SHDButton
              secondary
              label="Pause scoring"
              onClick={() => {
                onPauseScoring();
                hideModal(); // Close modal after action
              }}
            />
            <SHDButton
              warning
              label="End game"
              onClick={() => {
                onEndGame();
                hideModal(); // Close modal after action
              }}
            />
          </Box>
        </SHDModalContainer>
      </SHDFooter>
    </Box>
  );
};

export default ExitScoringModal;
